module.exports = __webpack_public_path__ + "img/GS_Profiles-Joseph Maruping.12d159bd.png";